import type { PaymentDetailsDiscrepancies } from '@approvalmax/types';
import { AlertCircleFilledIcon } from '@approvalmax/ui';
import { Flex, Table, Text } from '@approvalmax/ui/src/components';
import { ColumnDefinition } from '@approvalmax/ui/src/components/Table/Table.types';

import { messages } from './PaymentDetailsDiscrepanciesPopupContent.messages';

export const getTableColumns = (): ColumnDefinition<PaymentDetailsDiscrepancies>[] => [
    {
        id: 'name',
        name: messages.tableHeaderContact,
        cellComponent: (props) => (
            <Table.Cell {...props}>
                <Text font='label' ellipsis={1} fontSize='small' title={props.item.name}>
                    {props.item.name}
                </Text>
            </Table.Cell>
        ),
    },
    {
        id: 'modifiedProperties',
        name: messages.tableHeaderDiscrepancy,
        cellComponent: (props) => (
            <Table.Cell {...props}>
                <Flex spacing='8'>
                    <AlertCircleFilledIcon width={12} height={12} color='brandDext90' />

                    <div>
                        {props.item.modifiedProperties.map((property) => (
                            <Text key={property.name} font='label' ellipsis={1} fontSize='small' title={property.name}>
                                - {property.name}
                            </Text>
                        ))}
                    </div>
                </Flex>
            </Table.Cell>
        ),
    },
];
